function checkoutReload() {
  const checkoutPage = $('.woocommerce-checkout');

  // Scroll to top of the page on reload so user can see the error messages
  if (checkoutPage.length) {
    $(window).on('beforeunload', function () {
      setTimeout(() => {
        $(window).scrollTop(0);
      }, 500);
    });
  }
}

export function init() {
  checkoutReload();
}
